import React, { ReactNode } from 'react';
import { Card, CardBody } from 'reactstrap';

interface DepositDetailCardProps {
  title: string;
  children: ReactNode;
  className?: string;
}

const DepositDetailCard: React.FC<DepositDetailCardProps> = ({ title, children, className = '' }) => {
  return (
    <Card className={className}>
      <CardBody>
        <div className="d-flex flex-column">
          <small className="text-muted mb-2">{title}</small>
          {children}
        </div>
      </CardBody>
    </Card>
  );
};

export default DepositDetailCard;
